/** Estado de cobrança derivado no servidor (`02` §5). Valores novos caem no rótulo bruto. */
export type BillingState = 'Trial' | 'TrialEnded' | 'Active' | 'PastDue' | 'Canceled'

export type CreditEnforcement = 'Enforce' | 'Observe'

export type CreditConsumptionKind =
  'AgentExecution' | 'PlaygroundExecution' | 'TriageRun' | 'AudioTranscription'

export interface OpenInvoice {
  readonly id: string
  readonly number: string
  readonly amount: number
  readonly dueDate: string
  readonly paymentUrl: string | null
}

export interface UsageSummary {
  readonly state: string
  readonly enforcement: string
  readonly available: number
  readonly pausedForCredits: boolean
  readonly lowBalance: boolean
  readonly trialEndsAt: string | null
  readonly currentPeriodEnd: string | null
  readonly openInvoice: OpenInvoice | null
  readonly planCode: string | null
}

export interface UsageBucket {
  readonly kind: string
  readonly credits: number
  readonly consumed: number
  readonly expiresAt: string | null
}

export interface UsageByKind {
  readonly kind: string
  readonly credits: number
}

export interface UsageDaily {
  readonly date: string
  readonly credits: number
}

export interface UsageDetail {
  readonly summary: UsageSummary
  readonly buckets: readonly UsageBucket[]
  readonly byKind: readonly UsageByKind[]
  readonly daily: readonly UsageDaily[]
  readonly windowDays: number
}

export interface PublicPlans {
  readonly currency: string
  readonly trial: { readonly credits: number; readonly days: number }
  readonly plans: readonly {
    readonly code: string
    readonly monthlyPrice: number | null
    readonly selfServe: boolean
  }[]
}

export type UsageWindowOption = 7 | 30 | 90

export const USAGE_WINDOW_OPTIONS: readonly UsageWindowOption[] = [7, 30, 90]
